import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../order/OrderCreate.css';

const OrderLanding: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Lấy tableId từ query nếu có
  const params = new URLSearchParams(location.search);
  const tableId = params.get('tableId');

  const handleIndividualOrder = () => {
    if (tableId) {
      navigate(`/order/create?tableId=${tableId}`);
    } else {
      navigate('/order/create');
    }
  };

  const handleGroupOrder = () => {
    if (tableId) {
      navigate(`/orders/group-create?tableId=${tableId}`);
    } else {
      navigate('/orders/group-create');
    }
  };

  const handleJoinGroup = () => {
    navigate('/orders/group-join');
  };

  return (
    <div className="order-create-bg">
      <div className="order-create-container">
        <h2 className="order-create-title">CHÀO MỪNG ĐẾN VỚI CAFE</h2>
        
        <div style={{ 
          background: '#f8fafc', 
          border: '1px solid #e2e8f0', 
          borderRadius: 12, 
          padding: 24, 
          marginBottom: 32,
          textAlign: 'center'
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#1e293b' }}>🍽️ Chọn cách đặt món</h3>
          <p style={{ margin: '0 0 24px 0', color: '#64748b', fontSize: '16px' }}>
            Bạn muốn đặt món như thế nào?
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
            {/* Đặt món cá nhân */}
            <button 
              onClick={handleIndividualOrder}
              className="order-create-submit-btn"
              style={{ 
                padding: '20px', 
                fontSize: '16px',
                background: '#3b82f6',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = '#2563eb';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = '#3b82f6';
              }}
            >
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>👤</div>
              <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Đặt món cá nhân</div>
              <div style={{ fontSize: '14px', opacity: 0.9 }}>
                Đặt món và thanh toán riêng
              </div>
            </button>

            {/* Đặt món nhóm */}
            <button 
              onClick={handleGroupOrder}
              className="order-create-submit-btn"
              style={{ 
                padding: '20px', 
                fontSize: '16px',
                background: '#10b981',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = '#059669';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = '#10b981';
              }}
            >
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>👥</div>
              <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Tạo nhóm mới</div>
              <div style={{ fontSize: '14px', opacity: 0.9 }}>
                Tạo session cho nhóm đặt món
              </div>
            </button>
          </div>

          {/* Tham gia nhóm */}
          <div style={{ 
            borderTop: '1px solid #e2e8f0', 
            paddingTop: '20px',
            textAlign: 'center'
          }}>
            <p style={{ margin: '0 0 12px 0', color: '#64748b', fontSize: '14px' }}>
              Đã có session code từ người khác?
            </p>
            <button 
              onClick={handleJoinGroup}
              className="order-create-menu-add-btn"
              style={{ 
                padding: '12px 24px',
                fontSize: '14px',
                background: '#f59e0b',
                border: 'none',
                borderRadius: '6px',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              🔑 Tham gia nhóm
            </button>
          </div>
        </div>

        {/* Hướng dẫn */}
        <div style={{ 
          background: '#f0f9ff', 
          border: '1px solid #0ea5e9', 
          borderRadius: 8, 
          padding: 16,
          fontSize: '14px',
          color: '#0369a1'
        }}>
          <strong>💡 Hướng dẫn:</strong>
          <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
            <li><strong>Đặt món cá nhân:</strong> Mỗi người đặt và thanh toán riêng</li>
            <li><strong>Tạo nhóm mới:</strong> Tạo session code để nhiều người cùng đặt món</li>
            <li><strong>Tham gia nhóm:</strong> Nhập session code từ người tạo nhóm</li>
            <li>Session code có 3 số và hết hạn sau 2 giờ</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OrderLanding; 